import FooterPatient from '../components/footer'

export default {
  FooterPatient
}



// WEBPACK FOOTER //
// ./src/app/auth/terms/term/resources/components.js